import { getFirestore } from "firebase/firestore/lite";
import { initializeApp } from "firebase/app";
const API_KEY = process.env.REACT_APP_API_KEY;
const API_DOMAIN = process.env.REACT_APP_API_DOMAIN;
const APP_ID = process.env.REACT_APP_API_APP_ID;
const firebaseConfig = {
  apiKey: API_KEY,
  authDomain: API_DOMAIN,
  projectId: "portfolio-8d96f",
  storageBucket: "portfolio-8d96f.appspot.com",
  messagingSenderId: "473982285466",
  appId: APP_ID,
  measurementId: "G-33PDN0KTPF",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
